/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Log_Entry_1_TitleInputs */

const en_how_we_work_log_entry_1_title = /** @type {(inputs: How_We_Work_Log_Entry_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notice what changed`)
};

const lv_how_we_work_log_entry_1_title = /** @type {(inputs: How_We_Work_Log_Entry_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamanām, kas mainījies`)
};

/**
* | output |
* | --- |
* | "Notice what changed" |
*
* @param {How_We_Work_Log_Entry_1_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_log_entry_1_title = /** @type {((inputs?: How_We_Work_Log_Entry_1_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Log_Entry_1_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_log_entry_1_title(inputs)
	return en_how_we_work_log_entry_1_title(inputs)
});